// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Ee","srOnly":"Fe"};